"use client";

import React from "react";
import styles from "./CoreCards.module.scss";
import { CoreCard } from "@/components/ui/CoreCard";
import type { FeatureData } from "@/services/featureListing";

interface CoreCardsProps {
  title?: string;
  cores: FeatureData[];
  emptyMessage?: string | null;
}

/**
 * CoreCards - Wrapper component that renders a collection of CoreCard components
 * This is designed to work with the DynamicComponent system
 */
const CoreCards: React.FC<CoreCardsProps> = ({
  title,
  cores,
  emptyMessage,
}) => {
  if (!cores || cores.length === 0) {
    return (
      <section className={styles.coreCards}>
        <div className={styles.emptyState}>
          <p>{emptyMessage || "Nothing available for this filter."}</p>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.coreCards}>
      <div className="container mx-auto">
        <If condition={title}>
          <header className={styles.header}>
            <h2 className={styles.title}>{title}</h2>
          </header>
        </If>

        <div className={styles.cardsGrid}>
          {cores.map((core, index) => (
            <CoreCard key={core.sys.id} core={core} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

// Helper component for conditional rendering
const If: React.FC<{ condition: any; children: React.ReactNode }> = ({
  condition,
  children,
}) => (condition ? <>{children}</> : null);

export default CoreCards;
